// choices as selectable cards, stacked; multi-select toggles. Discrete
// input — saves on change.

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import ChoiceCard from "components/ChoiceCard";

import { FieldError, FieldHelper, FieldLabel } from "./chrome";
import { V2FieldProps } from "./types";

function toggle(current: unknown, ref: string): string[] {
  const selected = Array.isArray(current) ? current.map(String) : [];
  if (selected.includes(ref)) return selected.filter((item) => item !== ref);
  return [...selected, ref];
}

export default function ChoicesField({ field, onCommit }: V2FieldProps) {
  const { control, trigger } = useFormContext();

  const isAnswered = (value: unknown) => {
    if (field.allowMultiple) return Array.isArray(value) && value.length > 0;
    return value !== undefined && value !== null && value !== "";
  };

  return (
    <Controller
      control={control}
      name={field.ref}
      rules={{
        validate: (value) =>
          !field.required || isAnswered(value) || "Please choose one",
      }}
      render={({ field: rhf, fieldState: { error } }) => {
        const isSelected = (ref: string) => {
          if (field.allowMultiple) {
            return Array.isArray(rhf.value) && rhf.value.includes(ref);
          }
          return rhf.value === ref;
        };
        const choose = (ref: string) => {
          if (field.allowMultiple) {
            rhf.onChange(toggle(rhf.value, ref));
          } else {
            rhf.onChange(ref);
          }
          void trigger(field.ref);
          onCommit();
        };
        return (
          <div>
            <FieldLabel text={field.title} />
            <FieldHelper text={field.description} />
            <div className="mt-2 flex flex-col gap-2">
              {(field.choices ?? []).map((choice) => (
                <ChoiceCard
                  key={choice.ref}
                  selected={isSelected(choice.ref)}
                  onSelect={() => choose(choice.ref)}
                >
                  {choice.label}
                </ChoiceCard>
              ))}
            </div>
            <FieldError message={error?.message} />
          </div>
        );
      }}
    />
  );
}
